import { useState } from 'react';
import { lookupVoucherForCustomer } from '../services/voucherService';

export function useVoucherLookup() {
  const [voucher, setVoucher] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function lookupVoucher(values) {
    const normalizedVoucherCode = values?.voucherCode?.trim() || '';
    const normalizedPhone = values?.phone?.trim() || '';

    if (!normalizedVoucherCode && !normalizedPhone) {
      setVoucher(null);
      setError('Introduce un número de bono o un teléfono para buscar.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const result = await lookupVoucherForCustomer({
        voucherCode: normalizedVoucherCode || undefined,
        phone: normalizedPhone || undefined,
      });
      setVoucher(result);
    } catch (lookupError) {
      setVoucher(null);
      setError(lookupError?.response?.data?.message || 'No se pudo localizar el bono con los datos indicados.');
    } finally {
      setLoading(false);
    }
  }

  return {
    voucher,
    loading,
    error,
    lookupVoucher,
  };
}
